import type { User } from "@firebase/auth";

const pending = new WeakMap<User, Promise<string | null>>();

/** Refresh changed verification claims before an API action, without retrying the action itself. */
export async function verificationAwareToken(user: User, isCurrent: () => boolean): Promise<string | null> {
  if (!isCurrent()) return null;
  let request = pending.get(user);
  if (!request) {
    request = (async () => {
      const cached = await user.getIdTokenResult();
      if (!isCurrent()) return null;
      const verified = cached.claims.email_verified === true;
      if (!user.emailVerified || !verified) {
        await user.reload();
        if (!isCurrent()) return null;
        if (verified !== user.emailVerified) {
          const refreshed = await user.getIdToken(true);
          return isCurrent() ? refreshed : null;
        }
      }
      return cached.token;
    })();
    pending.set(user, request);
  }
  try { const token = await request; return isCurrent() ? token : null; }
  finally { if (pending.get(user) === request) pending.delete(user); }
}
